import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Institute } from '../models/institute.model';

@Injectable({ providedIn: 'root' })
export class InstituteService {
  private http = inject(HttpClient);

  getDefaultInstitute(): Observable<Institute> {
    return this.http.get<Institute>(`${environment.apiUrl}/institute`);
  }
}
